import { FaLock, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">

        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-red-50 text-red-500">
          {FaLock({ size: 32 })}
        </div>

        <h1 className="text-2xl font-bold text-gray-900">
          Access Restricted
        </h1>

        <p className="mt-3 text-gray-500 leading-relaxed">
          You don't have permission to access this page.
          Please contact your administrator if you believe you should have
          access.
        </p>

        <div className="mt-8 flex justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 rounded-xl bg-primary px-5 py-3 text-white font-medium hover:opacity-90 transition"
          >
            {FaArrowLeft({ size: 14 })}
            Go Back
          </button>
        </div>

      </div>
    </div>
  );
}